<template>
    <div class="wrapper">
        <h1 class="logo">Rate my joint</h1>
        <router-view />
    </div>
</template>

<script>

export default {
    name: 'App'
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

* {
    font-family: 'Source Sans 3', sans-serif;
}

html, body {
    margin: 0;
    padding: 0;
    background-color: $background-color;
}

.wrapper {
    .logo {
        text-align: center;
        margin: 40px 0 0 0;
    }
}

</style>
